import Checkbox from '../Checkbox/Checkbox';
import Input from '../Inputs/Input';
import { Radios } from '../RadioGroup/Radios';
import './RangeSelector.scss';

/**
 * RangeSelector component renders a customizable range selection UI.
 * @component
 *
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.selectorPrefix - Custom content to be rendered before the range selector.
 * @param {function} props.selectionTypeChange - Callback to be executed when the selection type changes "Manual"/"Range"
 * @param {React.ReactNode} props.selectorSuffix - Custom content to be rendered after the range selector.
 * @param {boolean} props.isRange - Controlled value of the selection Type (true for range selection).
 * @param {boolean} props.editing - Enable status
 * @param {function} props.newRange - Callback to be executed when adding a new range.
 * @param {Object[]} props.ranges - List of current Ranges
 * @param {function} props.updateRange - callback to update a range
 * @param {function} props.deleteRange - callback to remove a range
 * @param {string} props.rangeView -  "row"/"col"
 * @param {function} props.setRangeView - callback to change range view
 * @param {string} props.manualView -  "row"/"col"
 * @param {function} props.setManualView - callback to change manual view
 * @param {Object[]} props.itemList - List of items to select from
 * @param {string} props.itemLabel -  property on the item to by shown
 * @param {function} props.selectAll - callback to select all items
 * @param {function} props.deselectAll - callback to deselect all items
 * @param {function} props.updateItem - callback to update selection status on the item
 * @example
 * // Example usage:
 * <RangeSelector selectorPrefix={<div>This is some custom content</div>} />
 *
 * @returns {JSX.Element} The rendered RangeSelector component.
 */
export const RangeSelector = ({ tab, selectorPrefix, selectionTypeChange, selectorSuffix, isRange, editing, newRange, ranges, updateRange, deleteRange, rangeView, setRangeView, manualView, setManualView, itemList, itemLabel, selectAll, deselectAll, updateItem }) => {

    return (
        <div className='range-selector-component'>
            <div className='selection'>

                {/* <Input label="AC Type/ AC Series" /> */}
                {/* <Dropdowns filterFn={(opt) => !effList.find(i => i.aircraftTypeId === opt["c.id"]) } disabled={!editing} preSelectValue={eff.aircraftTypeId} onOptionSelect={(accFleet) => dispatch(updateEffectivity({ effTempId, name: "aircraftTypeId", value: accFleet["c.id"], obj: accFleet }))} selectionLabel="name" optionLabel="name" data={acTypeDrpdwn.config} parameters={accountParameter} /> */}
                {selectorPrefix}
                {/* <Radios disabled={!editing} onChange={(newV) => { dispatch(updateEffectivity({ effTempId, name: "selectionType", value: Boolean(newV === "true") ? "R" : "M" })) }} value={isRange} name="fixed" items={[{ value: false, label: "Manual Selection" }, { value: true, label: "Range Selection" }]} /> */}
                <Radios disabled={!editing} onChange={(newV) => { selectionTypeChange(newV) }} value={isRange} name="fixed" items={[{ value: false, label: "Manual Selection" }, { value: true, label: "Range Selection" }]} />
                {selectorSuffix}
            </div>
            {/* {JSON.stringify(eff)} */}
            {isRange ?
                <div className='ranges-selector'>
                    <div className='left-range-s'>
                        {/* <Input label="Range Type" /> */}
                        {/* <Dropdowns disabled={!editing} onOptionSelect={(rangeT) => dispatch(updateEffectivity({ effTempId, name: "rangeType", value: rangeT.id, obj: rangeT }))} preSelectValue={eff.rangeType} data={rangeDrpdwn.config} optionLabel="name" /> */}

                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>

                            <b>{tab === "PN" ? "Serial": "Line"} Number Range(s)</b>
                            {editing && <button onClick={() => newRange()} className='tiny filled' style={{ fontSize: "0.55rem" }}>
                                {/* <i className='icon-add-new' style={{fontSize: "0.2rem"}}></i> */}
                                Add Range
                            </button>}
                        </div>
                        <div className='range-list'>

                            {/* {
                        [1, 2, 3, 4].map((r, i) => <div key={r} className='range'>
                            <b>Range {i + 1}</b>
                            <div>
                                <span>From</span>
                                <Input label="" />
                                <span>To</span>
                                <Input label="" />
                            </div>
                            <i className='icon-delete-new'></i>


                        </div>)
                    } */}
                            {/* {JSON.stringify(ranges)} */}
                            {ranges?.length > 0 ?
                                ranges.map((r, i) =>
                                    <div className='range'>
                                        <b>Range {i + 1}</b>
                                        <div>
                                            <div className={`${r.error && 'error'}`}>

                                                <span>From</span>
                                                <Input disabled={disabled} isNumeric={['line', 'serial'].includes("line")} onChange={e => updateRange({ ...e, target: { ...e.target, name: "from" } }, i)} value={r.from} label="" />
                                                <span>To</span>
                                                <Input disabled={disabled} isNumeric={['line', 'serial'].includes("line")} onChange={e => updateRange({ ...e, target: { ...e.target, name: "to" } }, i)} value={r.to} label="" />
                                            </div>
                                            {Boolean(r.error) && <span>{r.error}</span>}
                                        </div>
                                        {!disabled && <i onClick={() => deleteRange()} className='icon-delete-new'></i>
                                        }

                                    </div>
                                )
                                :
                                <div className='placeholder-component'>
                                    <i>No ranges configured</i>
                                </div>
                            }
                        </div>

                    </div>
                    <div className='right-range-s'>
                        <div className='right-h'>
                            <b>Selected</b>
                            <i onClick={() => setRangeView("col")} className={`icon-menu rotated ${rangeView === "col" ? 'active' : ''}`}></i>
                            <i onClick={() => setRangeView("row")} className={`icon-menu ${rangeView === "row" ? 'active' : ''}`}></i>
                        </div>
                        <div className='array-container'>

                            {/* <div className='array'> */}



                            <div className='array'
                                style={
                                    rangeView === "col" ?
                                        { gridTemplateRows: `repeat(${Math.ceil(itemList.length / 7)}, 1fr)`, gridAutoFlow: 'column', gap: "0.2rem 0.5rem" }
                                        : { gridTemplateColumns: "repeat(7, 1fr)", gap: "0.5rem 0.2rem" }}
                            >

                                {itemList?.length > 0 ? (itemList).map(r =>
                                    <div className={`array-item ${r.selected ? 'active' : ''}`}>
                                        <i className='icon-check-2'></i>
                                        {/* {JSON.stringify(eff.rangeType)} */}
                                        <span>{r[itemLabel]}</span>
                                    </div>
                                ) :
                                    <div className='placeholder-component'>
                                        <i>No items to select from</i>
                                    </div>
                                }
                            </div>
                            {/* </div> */}
                        </div>

                    </div>

                </div>
                : <div className='manual-selector'>
                    <div className='right-h'>
                        <b>Selected</b>
                        <Input label="" placeholder="Search" />
                        <i onClick={() => setManualView("col")} className={`icon-menu rotated ${manualView === "col" ? 'active' : ''}`}></i>
                        <i onClick={() => setManualView("row")} className={`icon-menu ${manualView === "row" ? 'active' : ''}`}></i>
                        <div className='all-selectors'>
                            <button onClick={() => selectAll()} className='outlined small-size iconTextButton selectall'>
                                <Checkbox checked={true} disabled={false} outlined></Checkbox>
                                <b>Select All</b>
                            </button>
                            <button onClick={() => deselectAll()} className='outlined small-size iconTextButton deselectall'>
                                {/* <Checkbox disabled={false} outlined checked={false}></Checkbox> */}
                                <b>Deselect All</b>
                            </button>
                        </div>
                    </div>
                    <div className='range-list'>
                        <div className='array-container'>
                            <i>

                            </i>

                            <div className='array'
                                style={
                                    manualView === "col" ?
                                        { gridTemplateRows: `repeat(${Math.ceil(itemList.length / 7)}, 1fr)`, gridAutoFlow: 'column', gap: "0.2rem 0.5rem" }
                                        : { gridTemplateColumns: "repeat(7, 1fr)", gap: "0.5rem 0.2rem" }}
                            >
                                {itemList?.length > 0 ?
                                    itemList.map((r, j) => <div onClick={(e) => updateItem(r.id, !r.selected)} className={`array-item ${r.selected ? 'active' : ''}`}>
                                        <Checkbox disabled={!editing} outlined checked={r.selected} onChange={(newV) => { if (!editing) updateItem(r.id, newV) }} />
                                        <span>{r[itemLabel]}</span>
                                    </div>)
                                    :
                                    <div className='placeholder-component'>
                                        <i>No aircraft on the selected AC Type/AC Series</i>
                                    </div>
                                }
                            </div>




                            {/* <div className='array'>

                                {}
                            </div> */}
                        </div>
                    </div>
                </div>
            }

        </div>)

}